import { useInjection } from 'inversify-react';
import { ReactElement, useState } from 'react';
import { useLoader } from '../../../helpers/useLoader';
import { ACDLError, InputStatus } from '../../../models/error.model';
import { CreateApiKeyForm } from '../components/CreateApiKeyForm';
import { IIntegrationsService } from '../integrations.service';

export const CreateApiKeyFormContainer = (): ReactElement => {
  const integrationsService = useInjection(IIntegrationsService.$);
  const { withLoaderAsync } = useLoader();

  const [name, setName] = useState<string>('');
  const [nameState, setNameState] = useState<InputStatus>(InputStatus.empty());

  const handleEmailChange = (name: string): void => {
    setName(name);
    setNameState(InputStatus.empty());
  };

  const validateName = (value: string): boolean | undefined => {
    const nameState = InputStatus.valid();

    if (value.trim() === '') {
      nameState.addErrorCode('field_cant_be_empty');
    }

    if (!integrationsService.isNameUnique(value, '')) {
      nameState.addErrorCode('api_key_name_must_be_unique');
    }

    setNameState(nameState);
    return nameState.isValid;
  };

  const handleAddNewApiKey = async (): Promise<void> => {
    await withLoaderAsync(async (): Promise<void> => {
      if (!validateName(name)) {
        return;
      }
      const result = await integrationsService.createApiKey(name.trim());

      if (result instanceof ACDLError) {
        setNameState(InputStatus.buildFrom([result.isBadRequestWithCode(['API_KEY_NAME_TAKEN']) ? 'api_key_name_must_be_unique' : 'something_went_wrong']));
      } else {
        setName('');
        setNameState(InputStatus.empty());
      }
    }, 'add-api-key-button');
  };

  return (
    <CreateApiKeyForm
      name={name}
      nameStatus={nameState}
      onNameChange={handleEmailChange}
      validateName={validateName}
      onAddNewApiKey={handleAddNewApiKey}
    />
  );
};
